import { Injectable } from '@angular/core';
import { APP_CONFIG } from './app-config.service';

/**
 * @description
 *
 * The main purpose of this service is to store and retrieve data from the browser's sessionStorage
 *
 */
@Injectable({
  providedIn: 'root'
})
export class SessionService {

  /**
   * This method used to store item in the sessionStorage
   * @param key
   * @param value
   */
  public setItem(key: string, value: any) {
    const encodeReq = APP_CONFIG.ENCODE_SESSION === 'true';
    if (this.isSessionStorageEnabled()) {
      sessionStorage.setItem(key, encodeReq ? btoa(JSON.stringify(value)) : JSON.stringify(value));
    }
  }
  
  public setMemberSearchItem(key: string, value: any) {
    const encodeReq = APP_CONFIG.ENCODE_SESSION === 'true';
    if (this.isSessionStorageEnabled()) {
      sessionStorage.setItem(key, encodeReq ? window.btoa(encodeURIComponent(JSON.stringify(value))) : JSON.stringify(value));
    }
  }

  /**
   * This method used to get item from the sessionStorage based on the key
   * @param key
   * @returns the value based on the key provided or blank if no value is present
   */
  public getItem(key: string) {
    const encodeReq = APP_CONFIG.ENCODE_SESSION === 'true';
    if (this.isSessionStorageEnabled()) {
      let data = sessionStorage.getItem(key);
      if (data) {
        data = encodeReq ? atob(data) : data;
        try {
          return JSON.parse(data);
        } catch (e) {
          return data === 'undefined' ? '' : data;
        }
      }
    }
    return '';
  }
  
  public getMemberSearchItem(key: string) {
    const encodeReq = APP_CONFIG.ENCODE_SESSION === 'true';
    if (this.isSessionStorageEnabled()) {
      let data = sessionStorage.getItem(key);
      if (data) {
        data = encodeReq ? decodeURIComponent(window.atob(data)) : data;
        try {
          return JSON.parse(data);
        } catch (e) {
          return data === 'undefined' ? '' : data;
        }
      }
    }
    return '';
  }

  /**
   * This method is used to remove item from the sessionStorage based on the key
   */
  public removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  /**
   * This method will clear all the data stored in the user session
   */
  public clear() {
    sessionStorage.clear();
  }

  /**
   * This method returns true if sessionStorage is accessible, otherwise false
   */
  public isSessionStorageEnabled(): boolean {
    try {
      if (sessionStorage) {
        return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  }

}
